<!-- Bar (no markdown) -->
@if (state.showBar) {
  <div class="__wrap mat-elevation-z24" [class.is-active]="state.showBar">
    <div class="__grid">
      <div class="__message">
        <mat-icon class="__icon c-color--warn">warning</mat-icon>
        <h2 class="__title">
          New version of Zerops GUI ({{ state.version }}) was released, please reload your browser as soon as possible.
        </h2>
      </div>
      <div class="__button-wrap">
        <button
          mat-button
          type="button"
          (click)="onDismissBar$.next()">
          Ok, close.
        </button>
      </div>
    </div>
  </div>
}

<!-- Dialog (with markdown) -->
<zef-dialog
  [open]="state.dialogOpen"
  [options]="{ restoreFocus: false }"
  [autoFocus]="false"
  (closeTrigger)="onCloseDialog$.next()">

  <div class="__content">

    <zef-scrollbar
      class="__scroll"
      maxHeight="80vh">

      <zui-form-section
        class="__form-section"
        separator="none"
        [isZen]="false">
        <span *zuiFormSectionTitle>
          Version {{ state.version }} Available
        </span>

        <div *zuiFormSectionDesc>
          <span>A major version of Zerops GUI was released, read changelog below and refresh your browser window as soon as possible.</span>
        </div>
      </zui-form-section>

      @if (state.markdownContent) {
        <div class="__markdown" markdown [data]="state.markdownContent"></div>
      }

    </zef-scrollbar>

    <div class="__buttons">
      <button
        mat-flat-button
        color="accent"
        type="button"
        class="c-button--full"
        (click)="onCloseDialog$.next()">
        Got it
      </button>
    </div>

    <button
      type="button"
      class="__dialog-close-button"
      mat-icon-button
      (click)="onCloseDialog$.next()">
      <mat-icon>close</mat-icon>
    </button>

  </div>

</zef-dialog>
